<div class="banner-container" (click)="search()">
  <img [src]="imageUrl" alt="Banner image" class="banner-image" />
  <div class="banner-content">
    <h2>{{ region | placeName }}</h2>
    <img [src]="Utils.getFlagSrc(country)" [alt]="Utils.getFlagName(country)" style="width: 20px; height: 15px;">
  </div>
</div>

